module.exports = __webpack_public_path__ + "static/img/animales_11.80ca9237.jpg";